import { apiRequest, buildURL } from './commons/CommonService.Functions';

// models
import {
  CreatePersonEmailCommand,
  EmailViewModel,
  UpdatePersonEmailCommand
} from '../models/Entities/Person/Email/EmailModels';

const BaseURL = process.env.REACT_APP_BILLER_API_GATEWAY + 'persons';

// Get all emails of a person
export const GetEmailsByPersonId = async (
  token: string,
  personId: number
): Promise<EmailViewModel[]> => {
  const requestUrl: string = buildURL(BaseURL, personId, 'emails');
  return apiRequest<EmailViewModel[]>(requestUrl, token, 'GetEmailsByPersonId');
};

// Get email by id
export const GetEmailById = async (
  token: string,
  emailId: number
): Promise<EmailViewModel> => {
  const requestUrl: string = buildURL(BaseURL, 'emails', emailId);
  return apiRequest<EmailViewModel>(requestUrl, token, 'GetEmailById');
};

// Create email
export const CreateEmail = async (
  token: string,
  payload: CreatePersonEmailCommand
): Promise<EmailViewModel> => {
  const requestUrl: string = buildURL(BaseURL, 'emails');
  return apiRequest<EmailViewModel>(requestUrl, token, 'CreateEmail', {
    method: 'POST',
    body: JSON.stringify(payload)
  });
};

// Update email
export const UpdateEmail = async (
  token: string,
  payload: UpdatePersonEmailCommand
): Promise<EmailViewModel> => {
  const requestUrl: string = buildURL(BaseURL, 'emails');
  return apiRequest<EmailViewModel>(requestUrl, token, 'UpdateEmail', {
    method: 'PUT',
    body: JSON.stringify(payload)
  });
};

// Delete email
export const DeleteEmail = async (
  token: string,
  emailId: number
): Promise<number> => {
  const requestUrl: string = buildURL(BaseURL, 'emails', emailId);
  return apiRequest<number>(requestUrl, token, 'DeleteEmail', {
    method: 'DELETE'
  });
};
